import axios from 'axios'
import { Message } from 'element-ui'

const baseURL = process.env.NODE_ENV === 'development' ? '/ssy-mall-server' : ''

const http = axios.create({
  baseURL,
  timeout: 10000
})

http.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.token = token
  }
  return config
})

http.interceptors.response.use(
  response => {
    const payload = response.data
    if (payload && typeof payload.code !== 'undefined' && payload.code !== 0) {
      Message.error(payload.msg || '请求失败')
    }
    return response
  },
  error => {
    Message.error(error.message || '网络异常')
    return Promise.reject(error)
  }
)

export default http
